import { isDefined } from "@clipboard-health/util-ts";

import { useWorkerPendingShiftInvites } from "../../../redesign/WorkerShifts/ShiftInvites/api/useWorkerPendingShiftInvites";

export function usePendingShiftInviteCountByWorkplace(workplaceId: string | undefined) {
  const { data: shiftInvites, isSuccess } = useWorkerPendingShiftInvites({
    options: {
      enabled: isDefined(workplaceId),
    },
  });

  if (!isSuccess) {
    return 0;
  }

  return shiftInvites.data.filter((invite) => invite.attributes.workplaceId === workplaceId).length;
}
